<script setup lang="ts">
type SeoLink = {
  key: string;
  label: string;
  to: string | Record<string, unknown>;
};

type SeoLinkGroup = {
  key: string;
  title: string;
  links: SeoLink[];
};

defineProps<{
  groups: SeoLinkGroup[];
}>();
</script>

<template>
  <section v-if="groups.length" class="mt-10">
    <div class="max-w-[1220px] space-y-7 md:space-y-8">
      <section v-for="group in groups" :key="group.key">
        <h2 class="text-sm font-semibold leading-5 text-[#50555A] md:text-base">
          {{ group.title }}
        </h2>

        <p
          class="mt-1.5 text-sm leading-6 text-app-muted md:text-base md:leading-7"
        >
          <template v-for="(link, index) in group.links" :key="link.key">
            <NuxtLink
              :to="link.to"
              class="transition-colors duration-300 hover:text-primary animated-underline"
            >
              {{ link.label }}
            </NuxtLink>
            <span
              v-if="index < group.links.length - 1"
              class="text-app-placeholder"
            >
              ·
            </span>
          </template>
        </p>
      </section>
    </div>
  </section>
</template>
